import { render, staticRenderFns } from "./edit-single.vue?vue&type=template&id=1edafba2&"
import script from "./edit-single.vue?vue&type=script&lang=js&"
export * from "./edit-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports